/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DiscogsSearchArtistsInner } from './DiscogsSearchArtistsInner';
import {
    DiscogsSearchArtistsInnerFromJSON,
    DiscogsSearchArtistsInnerFromJSONTyped,
    DiscogsSearchArtistsInnerToJSON,
} from './DiscogsSearchArtistsInner';

/**
 * 
 * @export
 * @interface DiscogsSearch
 */
export interface DiscogsSearch {
    /**
     * 
     * @type {Array<DiscogsSearchArtistsInner>}
     * @memberof DiscogsSearch
     */
    artists: Array<DiscogsSearchArtistsInner>;
    /**
     * 
     * @type {Array<any>}
     * @memberof DiscogsSearch
     */
    sortArray: Array<any>;
    /**
     * 
     * @type {number}
     * @memberof DiscogsSearch
     */
    count: number;
}

/**
 * Check if a given object implements the DiscogsSearch interface.
 */
export function instanceOfDiscogsSearch(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "artists" in value;
    isInstance = isInstance && "sortArray" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function DiscogsSearchFromJSON(json: any): DiscogsSearch {
    return DiscogsSearchFromJSONTyped(json, false);
}

export function DiscogsSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscogsSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'artists': ((json['artists'] as Array<any>).map(DiscogsSearchArtistsInnerFromJSON)),
        'sortArray': json['sort_array'],
        'count': json['count'],
    };
}

export function DiscogsSearchToJSON(value?: DiscogsSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'artists': ((value.artists as Array<any>).map(DiscogsSearchArtistsInnerToJSON)),
        'sort_array': value.sortArray,
        'count': value.count,
    };
}

